import {RadioButtonInfo} from '../models';

export enum SortOptions {
    NEAREST = "NEAREST",
    HIGHEST_AMOUNT = "HIGHEST_AMOUNT",
    MOST_URGENT = "MOST_URGENT",
    MOST_RECENT = "MOST_RECENT",
}

export const locationsOptions: RadioButtonInfo<SortOptions>[] = [
    {
        value: SortOptions.NEAREST,
        label: {
            title: 'filters.sort.nearest',
        }
    },
    {
        value: SortOptions.HIGHEST_AMOUNT,
        label: {
            title: 'filters.sort.highestAmount',
        }
    },
    {
        value: SortOptions.MOST_URGENT,
        label: {
            title: 'filters.sort.mostUrgent',
        }
    },
    {
        value: SortOptions.MOST_RECENT,
        label: {
            title: 'filters.sort.mostRecent',
        }
    },
];
